/* eslint-disable */
// @ts-nocheck
import React from "react";
import { Pagination, PaginationNav } from "@carbon/react";

export const TablePagination = (props: {
  totalItems?: number;
  displayPageNum?: number;
  totalPages?: number;
  pageSize?: number;
  onPageChange: (pageNum: number) => void;
  onPageSizeChange: (pageNum: number) => void;
}) => {
  const {
    totalItems,
    displayPageNum,
    totalPages,
    pageSize,
    onPageSizeChange,
    onPageChange,
  } = props;

  return (
    <div className="pagination-bar" data-cy="paginationBar">
      <Pagination
        itemsPerPageText=""
        page={displayPageNum}
        pageSize={pageSize || 20}
        pageSizes={[10, 20, 30, 40, 50]}
        totalItems={totalItems}
        onChange={(e) => {
          onPageSizeChange(e.pageSize);
        }}
        data-cy="pagination"
      />

      <PaginationNav
        itemsShown={6}
        page={displayPageNum - 1}
        totalItems={totalPages}
        onChange={(e: number) => {
          onPageChange(e + 1);
        }}
      />
    </div>
  );
};
export default TablePagination;
